/**
 * Utility for building stream options for chat requests
 * Centralizes the logic for creating streaming configuration
 */
export function buildStreamOptions({
  mode,
  globalChatContext,
  isDevMode,
  isLLMOverrideEnabled,
  model,
  temperature,
  maxTokens,
  systemPrompt,
  automaticMessage,
  studentResponse,
}) {
  // Create stream options
  const streamOptions = {
    mode: mode, // Include mode for the streaming endpoint
  };

  if (typeof automaticMessage === 'boolean') {
    streamOptions.automaticMessage = automaticMessage;
  }

  // Include student response for practice mode if provided
  if (studentResponse !== undefined && studentResponse !== null) {
    streamOptions.studentResponse = studentResponse;
    console.log('Including studentResponse in stream options:', studentResponse);
  }

  console.log('globalChatContext', globalChatContext);

  // Set up courseId, unitId, and activityInstanceId if available in the context
  if (globalChatContext) {
    console.log('Using context for stream:', globalChatContext);

    if (globalChatContext.courseGuid) {
      streamOptions.courseId = globalChatContext.courseGuid;
      console.log('Setting courseId:', globalChatContext.courseGuid);
    }

    if (globalChatContext.unitGuid) {
      streamOptions.unitId = globalChatContext.unitGuid;
      console.log('Setting unitId:', globalChatContext.unitGuid);
    }

    // Include activityInstanceId for practice mode
    if (globalChatContext.activityInstanceId) {
      streamOptions.activityInstanceId = globalChatContext.activityInstanceId;
      console.log('Setting activityInstanceId:', globalChatContext.activityInstanceId);
    }
  }

  // Add LLM config and system prompt if in dev mode AND override is explicitly enabled
  if (isDevMode && isLLMOverrideEnabled) {
    // Add LLM config with temperature and maxTokens
    streamOptions.llmConfig = {
      model: model,
      temperature: temperature,
      maxTokens: maxTokens,
    };
    console.log('🔧 [DEV] LLM Override ENABLED - Using custom config:', streamOptions.llmConfig);

    // Add system prompt if custom
    if (systemPrompt && systemPrompt !== 'You are a helpful assistant that can answer questions and help with tasks.') {
      streamOptions.systemPrompt = systemPrompt;
    }
  } else if (isDevMode) {
    console.log('🔧 [DEV] LLM Override DISABLED - Using server defaults');
  }

  return streamOptions;
}
